import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the TS type for the slice state
export interface TotalRecordsCountState {
  totalRecordsCount: number;
  filteredRecordsCount: number;
}

// Define the initial value for the slice state
const initialState: TotalRecordsCountState = {
  totalRecordsCount: 0,
  filteredRecordsCount: 0,
};

export const TotalRecordsCountSlice = createSlice({
  name: "totalRecordsCount",
  initialState,
  reducers: {
    setTotalRecordsCount: (state, action: PayloadAction<number>) => {
      state.totalRecordsCount = action.payload;
    },
    setFilteredRecordsCount: (state, action: PayloadAction<number>) => {
      state.filteredRecordsCount = action.payload;
    }
  },
});

// Export the generated action creators for use in components
export const { setTotalRecordsCount, setFilteredRecordsCount } = TotalRecordsCountSlice.actions;

// Export the slice reducer for use in the store configuration
export default TotalRecordsCountSlice.reducer;
